export const MS_PER_DAY = 24 * 60 * 60 * 1000;
